export default "__VITE_ASSET__f404c8f3__"